import { DisputeStatus } from '@varo/graphql-schema-types';
import { Stack } from 'expo-router';
import useDisputesList from 'features/myVaro/hooks/disputes/useDisputesList';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import Button from 'shared/components/vxl/Button/Button';
import ExpoNavigationBar, {
  ExpoNavigationBarProps,
} from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import PillGroup from 'shared/components/vxl/navigation/PillGroup/PillGroup';
import theme from 'shared/styles/theme';
import {
  showZendeskArticle,
  zendeskArticleIds,
} from 'shared/utils/zendesk/zendeskUtils';

import DashboardScreen from './DashboardScreen';

interface DisputeTabProps {
  iconKey?: string;
  id: string;
  labelText: string;
}

const disputePillsData = [
  { id: 'open', labelText: 'Open' },
  { id: 'closed', labelText: 'Closed' },
];

export const openPill = disputePillsData[0].id;
export const closedPill = disputePillsData[1].id;

const DisputesScreen = () => {
  const [selectedTab, setSelectedTab] = useState(openPill);
  const [disputesStatus, setDisputesStatus] = useState(DisputeStatus.Open);

  const { t: translatedText } = useTranslation('myVaro', {
    keyPrefix: 'disputes',
  });

  useEffect(() => {
    if (selectedTab === closedPill) {
      setDisputesStatus(DisputeStatus.Closed);
    } else if (selectedTab === openPill) {
      setDisputesStatus(DisputeStatus.Open);
    }
  }, [selectedTab]);

  const { disputesListDetails, errorModel, loading } =
    useDisputesList(disputesStatus);

  const handleFaqAction = () => {
    try {
      showZendeskArticle(zendeskArticleIds.MY_VARO_DISPUTES);
    } catch (error) {
      console.error('Error showing Zendesk article:', error);
    }
  };

  return (
    <View style={styles.container}>
      <Stack.Screen
        options={{
          headerShown: true,
          headerBackVisible: true,
          title: translatedText('title'),
          header: (props: ExpoNavigationBarProps) => (
            <ExpoNavigationBar
              {...props}
              trailingAccessories={
                <Button
                  label={translatedText('buttons.faq')}
                  type="TEXT"
                  width="HUG"
                  onPress={handleFaqAction}
                />
              }
            />
          ),
        }}
      />
      {!errorModel ? (
        <PillGroup
          key={selectedTab}
          initialSelectedPillId={selectedTab}
          pillConfigs={disputePillsData}
          onSelection={(disputeData: DisputeTabProps) => {
            setSelectedTab(disputeData.id);
          }}
        />
      ) : null}
      <DashboardScreen
        disputesListDetails={disputesListDetails}
        errorModel={errorModel}
        loading={loading}
        selectedTab={selectedTab}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flexGrow: 1,
    flex: 1,
  },
});

export default DisputesScreen;
